export const EmptyDiv = () => <div />;
